import { AnalyticsBrowser, Analytics } from '@segment/analytics-next';
import { appConfig } from '@/config/app-config';

let analyticsInstance: Analytics | null = null;
let initialized = false;

export const analyticsService = {
  async init(options?: { writeKey?: string; debug?: boolean }) {
    if (initialized) return;

    const writeKey = options?.writeKey || appConfig.SEGMENT_API_KEY;
    if (!writeKey) {
      console.warn('Segment API key not provided. Analytics disabled.');
      return;
    }

    try {
      const [instance] = await AnalyticsBrowser.load({
        writeKey,
      });
      analyticsInstance = instance;
      initialized = true;

      if (options?.debug) {
        console.log('Segment analytics initialized');
      }
    } catch (error) {
      console.error('Failed to initialize Segment analytics:', error);
    }
  },

  isInitialized(): boolean {
    return initialized && analyticsInstance !== null;
  },

  identify(options: { id: string; traits?: Record<string, unknown> }) {
    if (!analyticsInstance) return;
    analyticsInstance.identify(options.id, options.traits);
  },

  track(event: string, properties?: Record<string, unknown>) {
    if (!analyticsInstance) return;
    analyticsInstance.track(event, properties);
  },

  trackNavigation(pathname: string, properties?: Record<string, unknown>) {
    if (!analyticsInstance) return;
    analyticsInstance.page(pathname, properties);
  },

  reset() {
    if (!analyticsInstance) return;
    analyticsInstance.reset();
  },

  // Test-only method to reset internal state
  __resetForTesting() {
    analyticsInstance = null;
    initialized = false;
  },
};

export const analytics = analyticsService;
